import './App.css';
import './i18n/i18n';

import { ReactNode } from 'react';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';

import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import useErrorReportingStore from './store/errorReportingStore/useErrorReportingStore';
import { useFeatureMetricsReporter } from './store/featureStore/hooks/useFeatureMetricsReporter';
import { routes } from './store/routeStore/constants/routes';
import { useNavigateWithCallback } from './store/routeStore/hooks/useNavigateWithCallback';

const AppAfterRouter = (): ReactNode => {
  useFeatureMetricsReporter();
  useNavigateWithCallback();

  return <Outlet />;
};

const { wrapCreateBrowserRouter } = useErrorReportingStore.getState();

const router = wrapCreateBrowserRouter(createBrowserRouter)([
  {
    children: routes,
    element: <AppAfterRouter />,
    errorElement: <ErrorBoundary />,
  },
]);

const App = (): ReactNode => <RouterProvider router={router} />;

export default App;
